import { ref, computed } from 'vue';

// Stato condiviso (singleton a livello di modulo) per la multi-selezione dei
// canali nella sezione "Channels" della sidebar.
//
// ChannelLeaf legge/scrive la selezione tramite la checkbox, mentre la sezione
// Channels (SidebarSubGroup) mostra il pulsante "Vedi N canali insieme" e
// applica il filtro conversazioni. Teniamo lo stato fuori dai componenti così i
// due lati restano allineati senza passare props attraverso la gerarchia.
const isSelectionMode = ref(false);
const selectedInboxIds = ref([]);

export function useChannelMultiSelect() {
  const selectedCount = computed(() => selectedInboxIds.value.length);

  const isSelected = inboxId => selectedInboxIds.value.includes(inboxId);

  const toggleInbox = inboxId => {
    if (isSelected(inboxId)) {
      selectedInboxIds.value = selectedInboxIds.value.filter(
        id => id !== inboxId
      );
    } else {
      selectedInboxIds.value = [...selectedInboxIds.value, inboxId];
    }
  };

  const clearSelection = () => {
    selectedInboxIds.value = [];
  };

  const enableSelectionMode = () => {
    isSelectionMode.value = true;
  };

  const disableSelectionMode = () => {
    isSelectionMode.value = false;
    clearSelection();
  };

  const toggleSelectionMode = () => {
    if (isSelectionMode.value) {
      disableSelectionMode();
    } else {
      enableSelectionMode();
    }
  };

  return {
    isSelectionMode,
    selectedInboxIds,
    selectedCount,
    isSelected,
    toggleInbox,
    clearSelection,
    enableSelectionMode,
    disableSelectionMode,
    toggleSelectionMode,
  };
}
